export default "__VITE_ASSET__UHa2t1BF__"